/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Submitfeedback1Inputs */

const en_feedback_submitfeedback1 = /** @type {(inputs: Feedback_Submitfeedback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit feedback`)
};

/**
* | output |
* | --- |
* | "Submit feedback" |
*
* @param {Feedback_Submitfeedback1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const feedback_submitfeedback1 = /** @type {((inputs?: Feedback_Submitfeedback1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Submitfeedback1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_feedback_submitfeedback1(inputs)
});
export { feedback_submitfeedback1 as "feedback_submitFeedback" }